// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".load-tab[data-v-f7ae6a3c] {\n  overflow: auto;\n}\n.load-tab .load-tab-title[data-v-f7ae6a3c] {\n  font-size: 1.125rem;\n  font-weight: 500;\n}\n.theme--light.load-tab[data-v-f7ae6a3c] {\n  background-color: #f6f6f6;\n}\n.theme--dark.load-tab[data-v-f7ae6a3c] {\n  background-color: #273039;\n}", ""]);
// Exports
module.exports = exports;
